"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('loader.items', function () {
    namespace_1.default.utils.extend(this, new namespace_1.default.loader());
    this.idPrefix = 'loader:items';
    /*
        Different because we need different default options.
    */
    this.getParams = function ( /* options */) {
        return namespace_1.default.params.loader.items;
    };
});
